import { t } from '@lingui/macro';
import { getProvinces } from 'api/api';
import { trans } from 'config/LinguiConfig';
import { change_alias, handleApi } from 'helper/helper';
import CustomSelect from 'MUI_Kit/components/CustomSelect/CustomSelect';
import React, { useEffect, useState } from 'react';

const SelectProvince = ({ value, onChange }) => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    let { data } = await handleApi(getProvinces());
    if (data) setData(data.map((item) => ({ key: item.id, value: item.name })));
  };

  const filterData = (keyword) => {
    return data.filter((item) => change_alias(item.value).includes(change_alias(keyword)));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <CustomSelect
      label={t`Tỉnh/thành phố`}
      data={data}
      value={value || ''}
      onChange={onChange('province')}
      filterData={filterData}
    />
  );
};

export default SelectProvince;
